import { render } from "./ChangeOwnPassword.vue?vue&type=template&id=690b51e4&scoped=true"
import script from "./ChangeOwnPassword.vue?vue&type=script&lang=js"
export * from "./ChangeOwnPassword.vue?vue&type=script&lang=js"

import "./ChangeOwnPassword.vue?vue&type=style&index=0&id=690b51e4&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690b51e4"]])

export default __exports__